export default __webpack_public_path__ + "static/media/office.f6f96e13.svg";